  // PortfolioStructure.js
  import React , { useEffect, useState } from 'react';
  import { useTranslation } from 'react-i18next';
  //import DOMPurify from 'dompurify';
  //import './PortfolioStructure.css';
  import PortfolioStructureHeader from './PortfolioStructure/PortfolioStructureHeader';
  import ChartComponent from './PortfolioStructure/ChartComponent';
  import PortfolioContent from './PortfolioStructure/PortfolioContent';
  
  import { toChartData } from './PortfolioStructure/PortfolioStructureTransformer';
  
  const PortfolioStructure = ({
	  akdBreakdownFundDataUrl,
	  productName,
	  PortfolioStructureHeaderLabels,
	  FundTypeDropdownValues,
	}) => {
	  const { t, i18n } = useTranslation();	
	  const [fundData, setFundData] = useState(null); 
	  const [structureData, setStructureData] = useState(null); 
	  const [asOfDate, setAsOfDate] = useState(null); 
	//   const [chartData, setChartData] = useState(null); 
	
	  useEffect(() => {
		const fetchData = async () => {
		let baseUrl = process.env.REACT_APP_DATA_URL || '#{DATA_URL}';

		  const fundResponse = await fetch(`${baseUrl}${akdBreakdownFundDataUrl}`);
	  
		  if (!fundResponse.ok) {
			throw new Error('HTTP error!');
		  }
	  
		  const fetchedFundDataArray = await fundResponse.json();
		  const fundDataObject = Array.isArray(fetchedFundDataArray) ? fetchedFundDataArray[0] : fetchedFundDataArray;


		  let funds;
		  if (fundDataObject && Array.isArray(fundDataObject.Breakdowns)) {
			funds = fundDataObject.Breakdowns.find(breakdown => breakdown.BreakdownTitle === "Detailansicht Einzelfonds");
		  }

		  
		  setFundData(funds)
		
		  let structure;
		  if (fundDataObject && Array.isArray(fundDataObject.Breakdowns)) {
			structure = fundDataObject.Breakdowns.find(breakdown => breakdown.BreakdownTitle === "Depotstruktur");
		  }

		  var transformedChartData = toChartData(structure?.values, productName, t, i18n);

		  setStructureData(transformedChartData);

		  setAsOfDate(fundDataObject?.BreakdownAsOfDate);

		  setTimeout(() => {
			window.applicationReInit(['Portfolio', 'FormSelect']);
		  }, 100);        
		};
	  
		fetchData().catch((error) => console.error(error));
  
	  }, [akdBreakdownFundDataUrl, productName, t, i18n]);
  
	  if (!fundData) {
		return <div>Loading...</div>;
	  }
  
	  return (
		<div className="m-portfolio-allocation l-grid">
			<PortfolioStructureHeader PortfolioStructureHeaderLabels={PortfolioStructureHeaderLabels} asOfDateFormatted={asOfDate} />
			<ChartComponent chartData={structureData} />
			<PortfolioContent FundTypeDropdownValues={FundTypeDropdownValues} DepotBreakdowns={fundData} />
		</div>
	)
  }
  
  export default PortfolioStructure;